import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-notification-icon',
  templateUrl: './notification.svg',
  styleUrls: ['./notification-icon.component.scss'],
})
export class NotificationIconComponent {
  @Input() bellStyle : any;

  @Input() bell: {strokeColor: '#FF7F50' | 'white' | 'none' | '#808080' | '#474747', fillColor: '#FF7F50' | 'white' | 'none' | '#808080' | '#474747'} = {
    strokeColor: 'white', fillColor: 'white'
  };
  @Input() circle: {strokeColor: '#D1433A' | 'white' | 'none', fillColor: '#D1433A' | 'white' | 'none'} = {
    strokeColor: '#D1433A', fillColor: '#D1433A'
  };
}
